

































import { Component, Vue } from "vue-property-decorator";

import BasePopup from "@/components/BasePopup/BasePopup.vue";
import EventBus from "@/utils/helpers/EventBus";
import { Action } from "vuex-class";
import { IUserLanguageData } from "./models/interfaces/session";

@Component({
  components: {
    BasePopup
  }
})
export default class App extends Vue {
  private showPermissionsPopup = false;

  public mounted() {
    EventBus.$on("show-permission-popup", () => {
      this.showPermissionsPopup = true;
    });
  }
}
